/* eslint-disable no-alert */
import React from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { Form, Row, Col, FormGroup, Input, Label } from 'reactstrap';
import { formatRp } from '../utils';

const Field = ({ label, children }) => (
  <Col sm={6} md={6}>
    <FormGroup row>
      <Label sm={4}>{label}</Label>
      <Col sm={7}>{children}</Col>
    </FormGroup>
  </Col>
);

const DateInput = (props) => (
  <DatePicker
    dateFormat="dd/MM/yyy"
    className="form-control date-picker-pym"
    {...props}
  />
);

const RequiredNote = ({ show, children }) =>
  show ? <div style={{ color: 'red' }}>{children}</div> : null;

/** The two-column PO header grid. Purely presentational. */
const PoHeaderForm = ({
  po,
  form,
  setField,
  setForm,
  mode,
  invalid,
  expenseTypes,
  branches,
  banks,
  bank,
  onBankChange,
  mutationDate,
  setMutationDate,
}) => {
  const disabled = mode.readOnly;

  const textField = (key) => ({
    type: 'text',
    className: 'is-invalid-edit',
    value: form[key],
    disabled,
    onChange: (e) => setField(key, e.target.value),
  });

  const handlePeriodStart = (date) =>
    setForm((current) => ({ ...current, periodStart: date, periodEnd: date }));

  const handlePeriodEnd = (date) => {
    if (date < form.periodStart) {
      alert('Period End date cannot be before the Period start date');
    } else {
      setField('periodEnd', date);
    }
  };

  return (
    <Form className="mt-2">
      <Row form>
        <Field label="Tujuan Pengeluaran">
          <Input
            className="is-invalid-edit"
            type="select"
            value={form.expenseTypeId}
            invalid={invalid('expenseTypeId')}
            onChange={(e) => setField('expenseTypeId', Number(e.target.value))}
            disabled={disabled}
          >
            <option value={0} hidden>
              -PILIH TUJUAN PENGELUARAN-
            </option>
            {expenseTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.tujuanPengeluaran}
              </option>
            ))}
          </Input>
        </Field>
        <Field label="Nomor Rekening Tujuan">
          <Input {...textField('targetAccountNumber')} />
        </Field>

        <Field label="PO Number">
          <Input
            type="text"
            className="is-invalid-edit"
            value={po?.code ?? ''}
            disabled
          />
        </Field>
        <Field label="Nama Rekening Tujuan">
          <Input {...textField('targetAccountName')} />
        </Field>

        <Field label="PO Date">
          <DateInput
            selected={po ? moment(po.tglPO).toDate() : null}
            disabled
          />
        </Field>
        <Field label="Nama Bank Tujuan">
          <Input {...textField('targetBankName')} />
        </Field>

        <Field label="Total Price">
          <Input
            type="text"
            className="is-invalid-edit"
            placeholder="Rp 0"
            value={formatRp(po?.totalPrice, 0)}
            disabled
          />
        </Field>
        <Field label="Cabang Tujuan">
          <Input {...textField('targetBranch')} />
        </Field>

        <Field label="Due Date">
          <DateInput
            selected={form.dueDate}
            disabled={disabled}
            onChange={(date) => setField('dueDate', date)}
          />
          <RequiredNote show={invalid('dueDate')}>
            Due date can&apos;t be empty
          </RequiredNote>
        </Field>
        <Field label="Remarks">
          <Input
            type="textarea"
            name="remarks"
            value={form.remarks}
            disabled={disabled}
            invalid={invalid('remarks')}
            onChange={(e) => setField('remarks', e.target.value)}
          />
        </Field>

        {mode.showBank && (
          <>
            <Field label="Choose Bank">
              <Input
                className="is-invalid-edit"
                type="select"
                value={bank.id ?? 0}
                disabled={mode.bankDisabled}
                onChange={(e) => onBankChange(e.target.value)}
              >
                <option value={0} hidden>
                  -PILIH BANK-
                </option>
                {banks.map((item) => (
                  <option key={item.id} value={item.id}>
                    {`${item.accountName} - (${item.accountNumber})`}
                  </option>
                ))}
              </Input>
            </Field>
            <Field label="Mutation Date">
              <DateInput
                selected={mutationDate}
                disabled={mode.mutationDisabled}
                onChange={setMutationDate}
              />
            </Field>
          </>
        )}

        <Field label="Period Start Date">
          <DateInput
            className="form-control date-picker-pym is-invalid-edit"
            selected={form.periodStart}
            disabled={disabled}
            onChange={handlePeriodStart}
          />
          <RequiredNote show={invalid('periodStart')}>
            Period start date can&apos;t be empty
          </RequiredNote>
        </Field>
        <Field label="Branch">
          <Input
            className="is-invalid-edit"
            type="select"
            value={form.branchId}
            invalid={invalid('branchId')}
            onChange={(e) => setField('branchId', e.target.value)}
            disabled={disabled}
          >
            <option value={0} hidden>
              -PILIH CABANG-
            </option>
            {branches.map((branch) => (
              <option key={branch.id} value={branch.id}>
                {branch.name}
              </option>
            ))}
          </Input>
        </Field>

        <Field label="Period End Date">
          <DateInput
            selected={form.periodEnd}
            disabled={disabled}
            onChange={handlePeriodEnd}
          />
          <RequiredNote show={invalid('periodEnd')}>
            Period end date can&apos;t be empty
          </RequiredNote>
        </Field>
      </Row>
    </Form>
  );
};

export default PoHeaderForm;
